import { Controller } from '@hotwired/stimulus'
import * as echarts from 'echarts'
import { optionsForChart } from '~/components/echarts/options'
import { csrfHeader } from '~/utils/csrf'

export default class EChartsController extends Controller {
  static values = {
    option: Object,
    url: String,
  }

  async connect() {
    const echart = echarts.init(this.element, null, {
      width: 'auto',
      height: 'auto',
    })

    if (this.hasUrlValue) {
      try {
        const response = await fetch(this.urlValue, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...csrfHeader(),
          },
        })
        const data = await response.json()
        const options = optionsForChart(data)
        echart.setOption(options)
      } catch (error) {
        console.error('Error fetching chart data:', error)
      }
    } else if (this.hasOptionValue) {
      echart.setOption(this.optionValue)
    }

    const resizeObserver = new ResizeObserver(() => echart.resize())
    resizeObserver.observe(this.element)
    resizeObserver.observe(document.querySelector('body'))
    this.echart = echart
    this.resizeObserver = resizeObserver
  }

  disconnect() {
    this.echart.dispose()
    this.resizeObserver.disconnect()
  }
}
